export const dataSelector = state => state.appData;
